// A mallard duck, modelled facing +X: a brown body, a green head, a yellow bill
// and a perky tail. Ported 1:1 from age-of-mcp's classic duck.ts.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  return [
    { geometry: new THREE.IcosahedronGeometry(0.036, 0), color: "#7a5a36",
      position: [0, 0.022, 0], scale: [1.6, 0.9, 1] },              // body on water
    { geometry: new THREE.CylinderGeometry(0.013, 0.016, 0.03, 5), color: "#1f7a4a",
      position: [0.055, 0.04, 0], rotation: [0, 0, -0.4] },          // neck
    { geometry: new THREE.IcosahedronGeometry(0.02, 0), color: "#1f7a4a",
      position: [0.07, 0.058, 0] },                                  // green head
    { geometry: new THREE.ConeGeometry(0.009, 0.026, 4), color: "#e0b020",
      position: [0.094, 0.054, 0], rotation: [0, 0, -Math.PI / 2] },   // bill
    { geometry: new THREE.ConeGeometry(0.013, 0.034, 4), color: "#5e4428",
      position: [-0.05, 0.03, 0], rotation: [0, 0, Math.PI / 2 + 0.5] }, // tail
  ];
}

export const duck = defineModel({
  id: "duck",
  batchId: "standard",
  name: "Duck",
  tags: ["creature","duck","low-poly","age-of-mcp","classic","water"],
  summary: "Low-poly duck.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.08,
  parts: () => partsFor(),
  animations: [],
});
